import mediator from "@tvg/mediator";

export const onClickContinueBtnGtmEvent = (module) =>
  mediator.base.dispatch({
    type: "REGISTRATION:CLICK_CONTINUE_BUTTON",
    payload: {
      module
    }
  });

export const onFormStepSuccessGtmEvent = (module) =>
  mediator.base.dispatch({
    type: "REGISTRATION:FORM_STEP_SUCCESS",
    payload: {
      module
    }
  });

export const onRegistrationAttemptGtmEvent = (module) =>
  mediator.base.dispatch({
    type: "REGISTRATION:REGISTRATION_ATTEMPT",
    payload: {
      module
    }
  });

export const onRegistrationCompleteGtmEvent = (
  verificationStatus,
  accountId,
  loginStatus,
  residenceState,
  promoCode
) =>
  mediator.base.dispatch({
    type: "REGISTRATION:REGISTRATION_COMPLETE",
    payload: {
      verificationStatus,
      accountId,
      loginStatus,
      residenceState,
      promoCode
    }
  });

export const onRegistrationFailureGtmEvent = (errorCode) =>
  mediator.base.dispatch({
    type: "REGISTRATION:REGISTRATION_FAILURE",
    payload: {
      errorCode
    }
  });

export const onRegistrationSignUpStartGtmEvent = () =>
  mediator.base.dispatch({
    type: "REGISTRATION:FORM_SIGN_UP_START"
  });
